import React, { useEffect, useState } from 'react';
import axios from "axios";
import { BASE_URL } from "../../config";
import { useNavigate } from 'react-router-dom';
import authStorage from "../../utils/authStorage";

const PaymentConfirm = ({back}) => {
    const [paymentDetail, setPaymentDetail] = useState('');
    const [deviceStatus, setDeviceStatus] = useState(false);
    const[checkSub,setCheckSub]=useState();
    const navigate = useNavigate();
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    const [email, setEmail] = useState(authStorage.getItem('email'));
    const [loading, setLoading] = useState(false);

    const getDeviceStatus = () => {
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token"),
            },
            url: `${BASE_URL}/user/device/status`, //your url
            method: "GET",
        }).then((res) => {
            setDeviceStatus(res.data.isFitbitConnected || res?.data?.isGarminConnected);
        });
    };

    const checkUserSubscription = () => {
       let subId=authStorage.getItem("subId");
        console.log("subID",subId);
        
        setLoading(true);
        axios({
            url: `${BASE_URL}/auth/check-subscription/${subId}`,
            method: "get",
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            }
        }).then((data) => {
            setPaymentDetail(data?.data);
            authStorage.setItem("subscribedStatus",true);
            authStorage.removeItem("subId");
            setLoading(false);
        });
    };

    useEffect(() => {
        getDeviceStatus();
        checkUserSubscription();
    }, []);

    const updateWalkthrough = (e) => {
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token"),
            },
            url: `${BASE_URL}/user/update/walkthrough`, //your url
            method: 'PUT',
            data: { walkThroughPending: true, walkThroughSteps: 1 }
        }).then((res) => {
            authStorage.setItem('walkthrough', JSON.stringify({ walkThroughPending: true, walkThroughSteps: 1 }))
        }).catch((err) => {
        });
    };

    const walkThroughPending = JSON.parse(authStorage.getItem('walkthrough'))?.walkThroughPending;

    return (
        <div className="justify-center m-8 p-4 md:p-6 bg-white rounded-lg" >
            <div className="flex justify-center mb-8">
                {loading ? (
                    // <div className="p-40">Processing...</div>
                    <div role="status">
    <svg aria-hidden="true" class="w-24 h-24 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
    <span class="sr-only">Loading...</span>
</div>
                ) : (
                    <div>
                        <div className="text-gray-900 text-2xl font-medium text-center mb-4 mt-10">
                            {paymentDetail?.status ? "Payment Successfull" : "Payment Not Successfull"}
                        </div>
                        {paymentDetail?.status && (
                            <div>

                            <div class="p-6 md:mx-auto text-center">

                                <svg viewBox="0 0 24 24" class="text-[#2995f7] w-16 h-16 mx-auto my-6">

                                    <path fill="currentColor"

                                        d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z">

                                    </path>

                                </svg>

                                <div class="text-center">

                                    <h3 class="md:text-2xl text-base text-gray-900 font-semibold text-center">Subscription Completed!</h3>

                                    <p class="text-gray-600 my-2">Thank you for completing your secure online payment.</p>

                                    <p> Have a great day!  </p>

                                </div>

                            </div>

                            <div class="flex justify-center">

                                <div class="flex justify-center">

                                    <a target="_blank" href={`${paymentDetail?.invoiceLink}`} class="px-4 ml-2 py-3 cursor-pointer z-10 bg-[#E53E14] font-medium rounded-lg border-[#E53E14] text-white no-underline" rel="noreferrer">

                                        View Invoice

                                    </a>

                                </div>

                                <div class="flex justify-center">

                                    <a target="_blank" href={`${paymentDetail?.invoiceDownloadUrl}`} class="px-4 ml-2 font-semibold py-3 cursor-pointer z-10 bg-white rounded-lg text-[#E53E14] no-underline border border-solid border-[#E53E14]" rel="noreferrer">

                                        Download Invoice

                                    </a>

                                </div>

                                <span class="relative flex justify-center">

                                    {walkThroughPending && (<span class="animate-ping absolute inline-flex h-full w-[68%] bg-sky-200 opacity-40 z-0"></span>)}

                                    <button onClick={() => { navigate('/device'); back(0);  }} class={`${!deviceStatus && 'ring-2 ring-slate-400'} px-4 ml-2 py-3 cursor-pointer z-10 bg-[#2995f7] font-medium rounded-lg border-[#2995f7] text-white
no-underline`} rel="noreferrer">

                                        Connect Device

                                    </button>

                                </span>

                            </div>

                            <div class="flex justify-center mt-10">

                                <a onClick={() => navigate('/membership')} href='' class="flex justify-center mx-2 w-20 py-2 bg-white rounded-lg text-[#E53E14] border-[#E53E14]" rel="noreferrer">

                                    Go Back

                                </a>

                            </div>

                        </div>

                        )}
                        {!paymentDetail?.status && (
                            <div>
                                <div class="p-6 md:mx-auto">
                                    <svg viewBox="0 0 24 24" class="text-red-600 w-16 h-16 mx-auto my-6">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </svg>
                                    <div class="text-center">
                                        <h3 class="md:text-2xl text-base text-gray-600 font-semibold text-center">Subscription Not Completed!</h3>
                                        <p class="text-gray-600 my-2">Please contact CFT Admin for more detail.</p>
                                    </div>
                                </div>
                                <div class="flex justify-center mt-10">
                                    <a onClick={() => navigate('/membership')} href='' class="flex justify-center mx-2 w-20 text-white py-2" rel="noreferrer">
                                        Go Back
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}
export default PaymentConfirm;